var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.display, _vm.justify, _vm.align, _vm.padding]},[_c('b-spinner',{attrs:{"small":"","label":"Small Spinner","type":"grow"}}),_c('p',{staticClass:"ml-3 mb-0 mt-1 d-desc__2"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }